import { render, staticRenderFns } from "./DyhStaffChange.vue?vue&type=template&id=461b05e5&scoped=true"
import script from "./DyhStaffChange.vue?vue&type=script&lang=ts"
export * from "./DyhStaffChange.vue?vue&type=script&lang=ts"
import style0 from "./DyhStaffChange.vue?vue&type=style&index=0&id=461b05e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461b05e5",
  null
  
)

export default component.exports